<template>
  <v-snackbar
    top
    multi-line
    v-model="show"
    :color="snackbar.color"
  >
    {{ snackbar.message }}
    <v-btn
      icon
      @click="dismiss"
    >
      <v-icon color="white">close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data: () => ({
      show: false
    }),
    computed: {
      ...mapState({
        snackbar: state => state.snackbar
      })
    },
    watch: {
      snackbar () {
        this.show = true
      }
    },
    methods: {
      dismiss () {
        this.show = false
      }
    }
  }
</script>